// extracted by mini-css-extract-plugin
export var chip = "_42-0";
export var filterDropdown = "_42-5";
export var filterItem = "_42-6";
export var icon = "_42-1";
export var removeButton = "_42-3";
export var removeIcon = "_42-4";
export var separator = "_42-2";